import { useEffect } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Sidebar from "../Sidebar";
import { useState } from "react";
import { createUser, getCompanies, getUserAddressAdmin, updateUser } from '../../utils/actions/allactions';
import { toast } from "react-toastify";


// Phone code country
import PhoneInput from 'react-phone-number-input'
import { validateAdmin, getToken } from "../../utils/helper";
import useDocumentTitle from '../../utils/useDocumentTitle';

import AddressModal from "./AddressModal/AddressModal";
import { getUserDetailsById } from "../../api/customer/master/userMasterApi";
import { Loading } from "../../components/Loading";
import GenericAddressComponent from "../../components/GenericAddressComponent/GenericAddressComponent";
import { addBillingAddress, deleteBillingAddress, getBillingAddressById, getCountry, getUserBillingAddressByUserId, updateBillingAddress } from "../../api/customer/masters/commonMastersApi";

const AddUser = () => {
    const [searchParams] = useSearchParams();
    const id = searchParams.get("userId");
    const [isLoading, setIsLoading] = useState(false);
    useDocumentTitle(`${id ? 'Update' : 'Add'} user`);
    const [userCountry, setUserCountry] = useState('');
    useEffect(() => {
        (async () => {
            try {
                const { country } = await getCountry();
                console.log("Comming Country :", country);
                setUserCountry(country);

            } catch (error) {
                console.log("Error while fetching country :", error);
            }
        })()

    }, []);


    useEffect(() => {
        if (id) {
            (async () => {
                try {
                    setIsLoading(true)
                    const response = await getUserDetailsById(id);
                    console.log(" 1111 Response :", response);
                    if (!response.success) {
                        throw new Error(response.message);
                    };
                    const { data } = response;

                    if (data) {
                        const { phoneNumber } = data;
                        setPhoneValue(phoneNumber);
                        let address = await getUserAddressAdmin(token, data._id);
                        const billingAddressResponse = await getUserBillingAddressByUserId(id);
                        console.log("Billing Address :", billingAddressResponse);
                        const billingAddress = billingAddressResponse.success ? billingAddressResponse.billingAddress : [];
                        console.log("Billing Address :", billingAddress);
                        setValues({
                            ...data,
                            companyName: data?.companySiteId?.companyName || "",
                            address,
                            billingAddress,
                        });
                        if (data) {
                            setCompaniesSite(data?.companySiteId?.companySite)
                            setIsActive(data?.accountStatus == 'Active')
                            const email = data?.email || "";
                            const fetchedCompanies = await getCompanies(token, email);
                            console.log("Fetched Companies :", fetchedCompanies);
                            setCompanies(fetchedCompanies);
                        }
                    }

                } catch (error) {
                    console.error(error);
                } finally {
                    setIsLoading(false);
                }
            })()

        }

    }, [id]);
    const token = getToken();
    const navigate = useNavigate();
    useDocumentTitle(`${id ? "Update" : "Add"} Client User`)
    const [error, setError] = useState("");
    const [phoneValue, setPhoneValue] = useState('');
    const [values, setValues] = useState({
        firstName: '',
        lastName: '',
        companyName: '',
        address: [],
        phoneNumber: '',
        email: '',
        userType: 'user',
        password: '',
        isVerified: true,
        userCompanySite: '',
        accountStatus: 'Active'
    });
    const [isActive, setIsActive] = useState(true);

    const [showAddressModal, setShowAddressModal] = useState(false);
    const [recentAddress, setRecentAddress] = useState([]);
    const [isEdit, setIsEdit] = useState(false);
    const [editId, setEditId] = useState("");
    const [companies, setCompanies] = useState([]);
    const [companySites, setCompaniesSite] = useState([]);
    // let isActive = true;
    const [showGenericAddressModal, setShowGenericAddressModal] = useState(false);
    const [billingAddressId, setBillingAddressId] = useState(null);
    console.log("Billing Address Id :", billingAddressId);


    const fetchCompanyDetails = async () => {
        const fetchedCompanies = await getCompanies(token, values.email);
        setCompanies(fetchedCompanies);
    }

    useEffect(() => {
        validateAdmin(token, navigate);
    }, []);




    const validateUserValues = () => {
        setError("");
        if (!values.firstName) {
            setError("First name is required");
            return false;
        }

        if (!values.lastName) {
            setError("Last name is required");
            return false;
        }

        if (!values.email) {
            setError("Email is required");
            return false;
        }
        if (values.email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
            setError("Invalid email address");
            return false;
        }

        if (!values.companyName) {
            setError("Company name is required");
            return false;
        }

        if (!values.userCompanySite) {
            setError("Company site is required");
            return false;
        }
        if (!values.address || values.address.length === 0) {
            setError("Shipping address is required");
            return false;
        }
        if (!values.billingAddress || values.billingAddress.length === 0) {
            setError("Billing address is required");
            return false;
        }

        return true;
    }


    const handleCreateUpdateUser = async () => {
        setError("")
        const isUserInputValid = validateUserValues();
        if (!isUserInputValid) return;
        if (!id) {
            const data = { ...values, phoneNumber: phoneValue || "" }
            const createdUser = await createUser(token, data);
            // console.log(createdUser.data.data)
            if (createdUser.data.data.message) {
                toast.error(createdUser.data.data.message)
            }
            if (createdUser.data.data.code === 11000) {
                toast.error("User already exists")
            } else {
                navigate('/admin/user-master');
                toast.success("User added successfully")
            }
        }
        else {
            const data = { ...values, phoneNumber: phoneValue || "", companyName: values?.companyName }
            // console.log("data",data)
            const updatedUser = await updateUser(token, data);
            navigate('/admin/user-master');
            toast.success("User updated successfully")
        }
    }



    const handledAddAddress = (addressData) => {
        let addedAddress = values.address ? values.address : [];
        addedAddress.push(addressData)
        setValues({ ...values, address: addedAddress })
    }


    const handleAddressOnChange = (newFormData, index) => {
        let allAddresses = values.address ? values.address : [];
        let address = allAddresses[index];
        address = newFormData;
        allAddresses[index] = address;
        setValues({ ...values, address: allAddresses })
    }

    // Code for Address modal in Admin

    const deleteData = async (i) => {
        const updatedAddress = values.address;
        if (i > -1) {
            updatedAddress.splice(i, 1);
        }
        setValues({ ...values, address: updatedAddress })
    }

    const editHandler = (index) => {
        console.log('index', index)
        setShowAddressModal(true);
        setIsEdit(true)
        setEditId(index)
    }

    const openAddressModalHandler = () => {
        if (values.address.length === 5) {
            toast.error('You can only add upto 5 Shipping address');
            return;
        }
        setShowAddressModal(true);
    };

    const handleCompanySelect = (e) => {
        const selectedName = e.target.value;
        const selectedCompany = companies && companies.find(c => c.companyName === selectedName);
        if (selectedCompany) {
            setCompaniesSite(selectedCompany.companySite || []);
            // reset selected site when company changes
            setValues({ ...values, companyName: selectedCompany.companyName, userCompanySite: "" });
        } else {
            setCompaniesSite([]);
            setValues({ ...values, companyName: "", userCompanySite: "" });
        }
    };

    const handleSiteSelect = (e) => {
        setValues({ ...values, userCompanySite: e.target.value })
    };

    const addBillingAddressFunction = async (data) => {
        setValues((pre) => {
            return { ...pre, billingAddress: [data, ...(Array.isArray(pre.billingAddress) ? pre.billingAddress : [])] }
        })
    };

    const getBillingAddressByIndex = (idx) => {
        const val = values.billingAddress[idx - 1];
        return new Promise((resolve, _) => resolve(val));

    };
    const billingAddressUpdateFunction = async (idx, data) => {
        setValues((pre) => {
            return { ...pre, billingAddress: pre.billingAddress.map((item, i) => i != idx - 1 ? item : data) }
        })
    };
    const deleteBilllingAddress = async (idx) => {
        setValues((pre) => {
            return { ...pre, billingAddress: pre.billingAddress.filter((_, i) => i != idx) }
        })


    }
    const handleEditBillingAddress = (id) => {
        setBillingAddressId(id);
        setShowGenericAddressModal(true);
    }

    const addNewBillingAddress = () => {
        if (values?.billingAddress?.length >= 5) {
            toast.error('You can only add upto 5 billing address');
            return;
        }
        setBillingAddressId(null);
        setShowGenericAddressModal(true);
    };

    return (
        <div className="admin-container">
            {isLoading ? <Loading /> : ""}
            {showAddressModal && (
                <AddressModal
                    addressModal={showAddressModal}
                    setShowAddressModal={setShowAddressModal}
                    setRecentAddress={setRecentAddress}
                    recentAddress={recentAddress}
                    isEdit={isEdit}
                    setIsEdit={setIsEdit}
                    id={editId}
                    setValues={setValues}
                    values={values}
                    handledAddAddress={handledAddAddress}
                    handleAddressOnChange={handleAddressOnChange}
                    userId={id}
                    userFirstName={values.firstName}
                    userLastName={values.lastName}

                />
            )}
            <GenericAddressComponent
                show={showGenericAddressModal}
                setShow={setShowGenericAddressModal}
                editAddressId={billingAddressId}
                getAddressById={getBillingAddressByIndex}
                onAddFunction={addBillingAddressFunction}
                onUpdateFunction={billingAddressUpdateFunction}
                userId={id}
                type="billing"
                userFirstName={values.firstName}
                userLastName={values.lastName}
                userAllShippingAddress={Array.isArray(values.address) ? values.address : []}
                isAdmin={true}

            />
            <div className="!bg-newPrimaryColor">
                <Sidebar />
            </div>
            <div className="admin-panel-container ">
                <h1 className="center-heading text-xl font-bold mt-2">  {id != undefined ? "Update" : "Add"} Client User</h1>

                <div className="edit-company-container">
                    <div>
                        <label htmlFor="firstName" >First Name </label>: &nbsp;
                        <input
                            name="firstName"
                            className="p-2 my-1"
                            type="text"
                            placeholder="Enter First name"
                            value={values.firstName}
                            onChange={(e) => { setValues({ ...values, firstName: e.target.value }) }}
                        />
                    </div>

                    <div>
                        <label htmlFor="lastName" >Last Name </label>: &nbsp;
                        <input
                            name="lastName"
                            className="p-2 my-1"

                            type="text"
                            value={values.lastName}
                            placeholder="Enter Last name"
                            onChange={(e) => { setValues({ ...values, lastName: e.target.value }) }}
                        />
                    </div>

                    <div>
                        <label htmlFor="email" >Email </label>: &nbsp;
                        <input
                            name="email"
                            className="p-2 my-1"

                            type="text"
                            value={values.email}
                            placeholder="Enter Email name"
                            onBlur={fetchCompanyDetails}
                            onChange={(e) => { setValues({ ...values, email: e.target.value }) }}
                        />
                    </div>

                    <div>
                        <label htmlFor="password" >Password</label>: &nbsp;
                        <input
                            name="password"
                            className="p-2 my-1"

                            type="password"
                            value={values.password}
                            placeholder="Enter Password"
                            onChange={(e) => { setValues({ ...values, password: e.target.value }) }}
                        />
                    </div>

                    <div style={{ display: 'flex', width: '100%' }}>
                        <div>
                            <label htmlFor="phone" >Phone </label>: &nbsp;
                        </div>
                        <div style={{ width: '40%' }}>
                            <PhoneInput
                                defaultCountry={userCountry?.toLowerCase()}
                                placeholder="Enter phone number"
                                name="phone"
                                value={phoneValue}
                                onChange={setPhoneValue}
                                className="p-2 my-1"

                            />
                        </div>
                    </div>
            {console.log("1111 Companies :", companies)   }
                    <div>
                        <label htmlFor="companyName" >Company Name </label>: &nbsp;
                        <select className="p-2 my-1" name='companyName' value={values.companyName || ""} onChange={handleCompanySelect}>
                            <option value="" disabled > Select Company</option>
                            {companies && companies.map((company, i) => (
                                <option key={i} value={company.companyName}>
                                    {company?.companyName}
                                </option>
                            ))}
                        </select>
                    </div>
                            {console.log("1111 Company Sites :", companySites)   }
                    <div>
                        <label htmlFor="companySite" >Company Site </label>: &nbsp;
                        <select className="p-2 my-1" name='companySite' value={values.userCompanySite || ""} onChange={(e) => handleSiteSelect(e)}>
                            <option value=""> Select Company Site</option>
                            {companySites && companySites.map((companySite, i) => (
                                <option key={i} value={companySite} >
                                    {companySite}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div>
                        <label htmlFor="compamy-status" >Account Status</label>: &nbsp;
                        <input
                            className="p-2 my-1"
                            name="company-status"
                            type="radio"
                            value="Active"
                            onChange={(e) => { setValues({ ...values, accountStatus: e.target.value }, setIsActive(true)) }}
                            checked={isActive}
                        />Active

                        <input
                            className="p-2 my-1"

                            name="company-status"
                            type="radio"
                            value="Inactive"
                            checked={!isActive}
                            onChange={(e) => { setValues({ ...values, accountStatus: e.target.value }, setIsActive(false)) }}
                        />Inactive
                    </div>


                    <div className="addresses my-2">
                        <div className="cardContainer">
                            <div onClick={openAddressModalHandler} className="addNewAddressCard">
                                <div
                                    className="addNewAddressText"
                                >
                                    + Add shipping address
                                </div>
                            </div>

                            {values.address?.map((elem, index) => {
                                return (
                                    <div key={index}>
                                        <div className="card">
                                            <div className="addressContainer">
                                                <div className="name">{elem.firstName} {elem?.lastName || ""}</div>
                                                <div className="address">
                                                    {elem?.addressLineOne}
                                                    <div className="landMark">
                                                        {" "}
                                                        {elem?.addressLineTwo}
                                                    </div>
                                                    <div className="state">{elem.city} {elem?.state} {elem?.postalCode}</div>
                                                    <div className="country">{elem?.country}</div>
                                                    <div className="mobile">
                                                        {elem?.phoneNo ? `Mobile: ${elem.dialCode ? `+${elem.dialCode}-` : ''}${elem.phoneNo}` : ''}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="addressButtons">
                                                <div className="btn" onClick={() => editHandler(index)} >Edit</div>
                                                <div className="btn" onClick={() => deleteData(index)}>Remove</div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}

                        </div>
                    </div>
                    <div className="addresses">
                        <div className="cardContainer ">
                            <div onClick={addNewBillingAddress} className="addNewAddressCard">
                                <div
                                    className="addNewAddressText"

                                >
                                    + Add billing address
                                </div>
                            </div>

                            {values.billingAddress?.map((elem, index) => {
                                return (
                                    <div key={index}>
                                        <div className="card">
                                            <div className="addressContainer">
                                                <div className="name">{elem.firstName} {elem?.lastName || ""}</div>
                                                <div className="address">
                                                    {elem?.addressLineOne}
                                                    <div className="landMark">
                                                        {" "}
                                                        {elem?.addressLineTwo}
                                                    </div>
                                                    <div className="state">{elem.city} {elem?.state} {elem?.postalCode}</div>
                                                    <div className="country">{elem?.country}</div>
                                                    <div className="mobile">
                                                        {elem?.phoneNo ? `Mobile: ${elem.dialCode ? `+${elem.dialCode}-` : ''}${elem.phoneNo}` : ''}

                                                    </div>
                                                </div>
                                            </div>
                                            <div className="addressButtons">
                                                <div className="btn" onClick={() => handleEditBillingAddress(index + 1)} >Edit</div>
                                                <div className="btn" onClick={() => deleteBilllingAddress(index)}>Remove</div>
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}

                        </div>
                    </div>


                    <div className="center-heading mt-5">
                        <button className="button-search" onClick={handleCreateUpdateUser} style={{ marginTop: '15px' }}>  {
                            id ? "Update User" : "Create User"} </button>
                    </div>
                    {
                        error ?
                            <div style={{ color: 'red', fontSize: '15px', textAlign: 'center', marginTop: '10px' }}>{error}</div>
                            : null
                    }

                </div>
            </div>
        </div >
    )
}

export default AddUser;